module.exports = "../fonts/vendor/primevue/resources/themes/lara-light-indigo/Inter-Light.woff?994e34451cc19ede31d30802a480542b";